<template>
  <div class="flex items-center gap-4 bg-white">
    <SearchInput class='flex-1 md:flex-initial' v-model='model' />
    <button class='flex items-center gap-1' @click='openSidebar'>
      <FunnelIcon class='w-5' />
      <div class='rounded-full w-1 h-1 bg-black' v-if='query.hasFilters()' />
    </button>
    <SidebarLayout ref='sidebar'>
      <template #title>
        Filters
      </template>
      <template #main>
        <form>
          <div class="divide-y divide-gray-200">
            <div class="space-y-6 pb-5">
              <Component v-for='filter in filters' :is='filter.input' v-model='filter.state.model' v-bind='filter.props || {}' />
            </div>
          </div>
        </form>
      </template>
    </SidebarLayout>
  </div>
</template>

<script setup>

import { ref, watch, reactive, computed } from 'vue';

import { FunnelIcon } from '@heroicons/vue/24/outline';

import SidebarLayout from '@/components/layouts/sidebar-layout.vue';

import SearchInput from '@/components/inputs/search-input.vue';

const props = defineProps({
  query: Object,
  searchKeys: Array,
  filters: Array
});

const sidebar = ref();

const openSidebar = () => {
  sidebar.value.open();
}

const model = ref();

watch(model, () => {
  if (!model.value) {
    props.query.clearSearch();
    return;
  }
  
  props.query.setSearch(props.searchKeys, model.value);
});

const filters = props.filters.map((filter) => {
  return {
    ...filter,
    state: props.query.connectFilter(filter.key, filter.adapter)
  }
});

</script>